import { checkFrequencyLabel, type RuleFormValues } from './ruleFormModel';

export function triggerSourceLabels(
  values: Pick<RuleFormValues, 'source' | 'conditions'>
): string[] {
  const labels: string[] = [];
  const seen = new Set<string>();
  const add = (raw?: string | null) => {
    const label = raw?.trim();
    if (!label || seen.has(label)) return;
    seen.add(label);
    labels.push(label);
  };
  add(values.source?.layerLabel);
  for (const condition of values.conditions ?? []) {
    add(condition.source?.layerLabel);
  }
  return labels;
}

export function saveEnableConfirmIntervalText(
  repeatPattern?: string | null,
  sourceLabels: string[] = []
): string {
  const interval = checkFrequencyLabel(repeatPattern).toLowerCase();
  if (sourceLabels.length === 0) {
    return `Once enabled, PRATUS will check the trigger data source ${interval}.`;
  }
  if (sourceLabels.length === 1) {
    return `Once enabled, PRATUS will check ${sourceLabels[0]} ${interval}.`;
  }
  return `Once enabled, PRATUS will check ${sourceLabels.join(', ')} ${interval}.`;
}
